<template>
  <div class="application">
    <NavBarSection />
    <HeaderSection :size="headerSize" />
    <router-view />
    <FooterSection />
  </div>
</template>

<script>
import HeaderSection from '@/sections/Header';
import FooterSection from '@/sections/Footer';
import NavBarSection from '@/sections/NavBar';
import constants from '@/assets/constants.js';

export default {
  name: 'MainApplication',
  components: { HeaderSection, FooterSection, NavBarSection },
  computed: {
    headerSize: function() {
      const { meta: { headerSize = 'small' } } = this.$route;
      return headerSize;
    }
  },
  watch: {
    '$route' ({ name }) {
      document.title = (name !== 'Home')
        ? `${constants.TITLE} - ${name}`
        : constants.TITLE;
    }
  },
}
</script>
